<template>
  <div>
    <vs-prompt
      title="Select product to add"
      @cancel="val = ''"
      @accept="accept"
      :active.sync="prompt"
      accept-text="Add product"
      :is-valid="validForm"
      class="add-booking-product-popup"
    >
      <Loading v-if="isLoading" />
      <div v-else class="data-list-container data-list-list-view">
        <vs-table
          v-if="filteredProducts"
          ref="table"
          class="mt-8"
          pagination
          search
          maxItems="4"
          v-model="selectedProduct"
          :data="filteredProducts"
          noDataText="No data"
        >
          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
            <!-- ITEMS PER PAGE -->
          </div>
          <template slot="thead">
            <vs-th sort-key="id">Identifier</vs-th>
            <vs-th sort-key="name">Name</vs-th>
            <vs-th sort-key="price">Price</vs-th>
            <vs-th sort-key="updatedAction">Last updated</vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
                <vs-td :data="tr.id">
                  <p class="product-name font-medium truncate">
                    {{ tr.id }}
                  </p>
                </vs-td>
                <vs-td :data="tr.name" class="flex flex-row">
                  <div class="flex items-center">
                    <img v-if="tr.imageUrl" :src="tr.imageUrl" width="98" height="98" class="mr-3 rounded" />
                    <div>
                      <p class="product-name font-medium truncate">
                        {{ tr.name }}
                      </p>
                      <p class="product-name truncate text-muted">
                        {{ tr.description }}
                      </p>
                    </div>
                  </div>
                </vs-td>
                <vs-td>
                  <p class="product-category">
                    <span>
                      {{ tr.price }}
                    </span>
                    <span v-if="tr.beforePrice != 0">
                      <span class="text-muted">({{ tr.beforePrice }})</span>
                    </span>
                  </p>
                </vs-td>

                <vs-td>
                  <p class="product-category">
                    {{ moment(tr.updatedAction.timestamp).format("DD-MM-YYYY") }}
                  </p>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      moment,
      prompt: false,
      selectedProduct: null,
    };
  },
  props: {
    existingProducts: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters({
      bookingProducts: "bookingProducts/bookingProducts",
      isLoading: "bookingProducts/isLoading",
    }),
    validForm() {
      return this.selectedProduct != null;
    },

    // Filter out products already in the booking form
    filteredProducts() {
      console.log("Existing products", this.existingProducts);
      return this.bookingProducts.filter(product => {
        return !this.existingProducts.find(existingProduct => existingProduct.id === product.id);
      });
    },
  },
  methods: {
    show() {
      this.prompt = true;
    },
    async accept() {
      this.$emit("productSelected", this.selectedProduct);
    },
  },

  async mounted() {
    await this.$store.dispatch("bookingProducts/getAll");
  },
};
</script>

<style lang="scss">
.add-booking-product-popup {
  .vs-dialog {
    max-width: 900px;

    .header-table.vs-table--header {
      margin-left: 0 !important;
    }
  }
}
</style>
